import React from "react";
import SoftBox from "../../components/SoftBox";
import lockedGif from "../../img/locked-gradient.gif";

const BadGuyMobileCard = ({ title, image, isLocked, isSelected, onSelect }) => (
  <SoftBox
    component="button"
    type="button"
    // Locked tiles show a clear locked state (the gif overlay below) but were
    // still selectable — tapping one flipped selectedIndex to a Bad Guy with
    // no `info` entry, leaving the detail panel showing just a title and no
    // description. Ignore taps here instead of navigating to that dead end.
    onClick={() => { if (!isLocked) onSelect?.(); }}
    aria-disabled={isLocked}
    sx={{
      position: "relative",
      display: "block",
      width: "100%",
      aspectRatio: "3 / 4",
      borderRadius: "12px",
      overflow: "hidden",
      padding: 0,
      cursor: isLocked ? "default" : "pointer",
      backgroundImage: `url(${image})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      border: isSelected ? "2px solid #4F46E5" : "none",
    }}
  >
    {/** Locked overlay — one centered lock icon, no corner badge */}
    {isLocked && (
      <SoftBox
        sx={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(20,20,20,0.45)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img src={lockedGif} alt="" width={40} height={40} />
      </SoftBox>
    )}

    {/** Horizontal label overlay, anchored to the bottom */}
    <SoftBox
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        bottom: 0,
        padding: "8px 10px",
        background: "rgba(0,0,0,0.55)",
      }}
    >
      <SoftBox
        component="span"
        sx={{
          display: "block",
          fontFamily: "DM Sans",
          fontWeight: 700,
          fontSize: "12px",
          lineHeight: "16px",
          color: "#FFF",
          textAlign: "left",
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        {title}
      </SoftBox>
    </SoftBox>
  </SoftBox>
);

export default BadGuyMobileCard;
